import { Box } from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import { colors } from '../../styles/theme/colors';

const dotSizeSmall = 16;
const dotSizeLarge = 18;

const styles = {
    regular: {
        backgroundColor: colors.secondary1,
        width: dotSizeSmall,
        height: dotSizeSmall,
    },
    selected: {
        backgroundColor: colors.pink2,
        width: dotSizeLarge,
        height: dotSizeLarge,
    },
} as const;

type PageDotIndicatorProps = {
    count: number;
    currentPage: number;
    onSelect?: (index: number) => void;
};

export function PageDotIndicator(props: PageDotIndicatorProps) {
    const {
        count,
        currentPage,
        onSelect,
    } = props;

    const dots = new Array(count).fill(undefined);

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                gap: 3,
                overflow: 'hidden',
                flexWrap: 'wrap',
                marginBottom: 2,
            }}
        >
            {dots.map((_, index) => (
                <Box
                    key={index}
                    sx={{
                        display: 'flex',
                        flexWrap: 'nowrap',
                        alignItems: 'center',
                        // Using min-height to make sure the dots are always the same size, and not make the page jump
                        // and down when changing between selected and regular.
                        minHeight: dotSizeLarge,
                    }}
                    onClick={() => onSelect?.(index)}
                >
                    <Box
                        sx={{
                            borderRadius: '50%',
                            flex: 1,
                            transition: 'all 0.3s ease-in-out',
                            ...(currentPage === index ? styles.selected : styles.regular),
                        }}
                    >
                        <Box sx={visuallyHidden} component="span">
                            {index + 1}
                        </Box>
                    </Box>
                </Box>
            ))}
        </Box>
    );
}
